module.exports = __webpack_public_path__ + "static/media/FoodOrder.c6a0ca40.jpg";